import React, { useEffect, useMemo, useState } from "react";
import { accessApi } from "../../services/accessApi";

export default function ITModulesPage() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [showModal, setShowModal] = useState(false);
const [saving, setSaving] = useState(false);
const [editingRow, setEditingRow] = useState(null);
const [form, setForm] = useState({
  code: "",
  name: "",
  description: "",
  sort_order: 0,
  is_active: 1,
  reason: "",
});

const openCreate = () => {
  setEditingRow(null);
  setForm({
    code: "",
    name: "",
    description: "",
    sort_order: 0,
    is_active: 1,
    reason: "",
  });
  setShowModal(true);
};

const openEdit = (row) => {
  setEditingRow(row);
  setForm({
    code: row.code || "",
    name: row.name || "",
    description: row.description || "",
    sort_order: row.sort_order ?? 0,
    is_active: Number(row.is_active) === 1 ? 1 : 0,
    reason: "",
  });
  setShowModal(true);
};

const toggleStatus = async (row) => {
  try {
    await accessApi.updateModuleStatus(row.id, {
      is_active: Number(row.is_active) === 1 ? 0 : 1,
      reason:
        Number(row.is_active) === 1
          ? "Deactivated from IT Admin"
          : "Activated from IT Admin",
    });

    await load();
  } catch (err) {
    console.error("toggleStatus error:", err);
    alert(err?.response?.data?.message || err.message || "Failed to update module status.");
  }
};

const saveModule = async () => {
  try {
    setSaving(true);

    const payload = {
      code: form.code,
      name: form.name,
      description: form.description,
      sort_order: Number(form.sort_order) || 0,
      is_active: form.is_active ? 1 : 0,
      reason: form.reason || null,
    };

    if (editingRow?.id) {
      await accessApi.updateModule(editingRow.id, payload);
    } else {
      await accessApi.createModule(payload);
    }

    setShowModal(false);
    await load();
  } catch (err) {
    console.error("saveModule error:", err);
    alert(err?.response?.data?.message || err.message || "Failed to save module.");
  } finally {
    setSaving(false);
  }
};

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      setLoading(true);
      setError("");
      const res = await accessApi.getModules();
      setRows(res?.data?.data || []);
    } catch (err) {
      console.error("ITModulesPage load error:", err);
      setError(err?.response?.data?.message || err.message || "Failed to load modules.");
    } finally {
      setLoading(false);
    }
  };

  const filteredRows = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return rows;

    return rows.filter((row) =>
      [row.code, row.name, row.description]
        .filter(Boolean)
        .join(" ")
        .toLowerCase()
        .includes(needle)
    );
  }, [rows, q]);

  if (loading) return <div className="p-6 text-black dark:text-white">Loading modules...</div>;
  if (error) return <div className="p-6 text-red-600 dark:text-red-400">{error}</div>;

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-black dark:text-white">Modules</h1>
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
          Review active application modules and catalog structure.
        </p>
      </div>

      <div className="flex items-center justify-between gap-3">
  <div />
  <button
    onClick={openCreate}
    className="px-4 py-2 rounded-xl bg-yellow-500 text-black font-medium"
  >
    + Add Module
  </button>
</div>

      <div className="rounded-2xl border border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-900 p-4">
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search modules..."
          className="w-full rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-950 px-3 py-2 text-black dark:text-white"
        />
      </div>

      <div className="rounded-2xl border border-gray-200 dark:border-neutral-700 bg-white dark:bg-neutral-900 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[900px]">
            <thead className="bg-gray-50 dark:bg-neutral-800">
              <tr className="border-b border-gray-200 dark:border-neutral-700">
                <th className="text-left p-3 text-gray-700 dark:text-gray-200 font-semibold">Code</th>
                <th className="text-left p-3 text-gray-700 dark:text-gray-200 font-semibold">Name</th>
                <th className="text-left p-3 text-gray-700 dark:text-gray-200 font-semibold">Description</th>
                <th className="text-left p-3 text-gray-700 dark:text-gray-200 font-semibold">Sort</th>
                <th className="text-left p-3 text-gray-700 dark:text-gray-200 font-semibold">Status</th>
                <th className="text-left p-3 text-gray-700 dark:text-gray-200 font-semibold">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredRows.map((row) => (
                <tr
                  key={row.id}
                  className="border-b border-gray-100 dark:border-neutral-800 hover:bg-gray-50 dark:hover:bg-neutral-800/60 transition"
                >
                  <td className="p-3 text-black dark:text-white font-medium">{row.code}</td>
                  <td className="p-3 text-black dark:text-white">{row.name}</td>
                  <td className="p-3 text-gray-700 dark:text-gray-300">{row.description || "-"}</td>
                  <td className="p-3 text-black dark:text-white">{row.sort_order}</td>
                  <td className="p-3 text-black dark:text-white">{Number(row.is_active) === 1 ? "Active" : "Inactive"}</td>
                  <td className="p-3">
  <div className="flex flex-wrap gap-2">
    <button
      onClick={() => openEdit(row)}
      className="px-3 py-1 rounded-lg border border-gray-300 dark:border-neutral-700"
    >
      Edit
    </button>

    <button
      onClick={() => toggleStatus(row)}
      className="px-3 py-1 rounded-lg border border-gray-300 dark:border-neutral-700"
    >
      {Number(row.is_active) === 1 ? "Deactivate" : "Activate"}
    </button>
  </div>
</td>
                </tr>
              ))}

              {filteredRows.length === 0 && (
                <tr>
                  <td colSpan={6} className="p-8 text-center text-gray-500 dark:text-gray-400">
                    No modules found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

{showModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
    <div className="w-full max-w-2xl rounded-2xl bg-white dark:bg-neutral-900 border border-gray-200 dark:border-neutral-700 p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold text-black dark:text-white">
          {editingRow ? "Edit Module" : "Add Module"}
        </h2>
        <button
          onClick={() => setShowModal(false)}
          className="px-3 py-1 rounded-lg border border-gray-300 dark:border-neutral-700"
        >
          Close
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm mb-1 text-black dark:text-white">Code</label>
          <input
            value={form.code}
            onChange={(e) => setForm((prev) => ({ ...prev, code: e.target.value }))}
            disabled={!!editingRow}
            className="w-full rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-950 px-3 py-2 text-black dark:text-white"
          />
        </div>

        <div>
          <label className="block text-sm mb-1 text-black dark:text-white">Name</label>
          <input
            value={form.name}
            onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))}
            className="w-full rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-950 px-3 py-2 text-black dark:text-white"
          />
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm mb-1 text-black dark:text-white">Description</label>
          <textarea
            value={form.description}
            onChange={(e) => setForm((prev) => ({ ...prev, description: e.target.value }))}
            rows={3}
            className="w-full rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-950 px-3 py-2 text-black dark:text-white"
          />
        </div>

        <div>
          <label className="block text-sm mb-1 text-black dark:text-white">Sort order</label>
          <input
            type="number"
            value={form.sort_order}
            onChange={(e) => setForm((prev) => ({ ...prev, sort_order: e.target.value }))}
            className="w-full rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-950 px-3 py-2 text-black dark:text-white"
          />
        </div>

        <div>
          <label className="block text-sm mb-1 text-black dark:text-white">Status</label>
          <select
            value={form.is_active}
            onChange={(e) => setForm((prev) => ({ ...prev, is_active: Number(e.target.value) }))}
            className="w-full rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-950 px-3 py-2 text-black dark:text-white"
          >
            <option value={1}>Active</option>
            <option value={0}>Inactive</option>
          </select>
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm mb-1 text-black dark:text-white">Reason</label>
          <input
            value={form.reason}
            onChange={(e) => setForm((prev) => ({ ...prev, reason: e.target.value }))}
            placeholder="Optional audit reason"
            className="w-full rounded-xl border border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-950 px-3 py-2 text-black dark:text-white"
          />
        </div>
      </div>

      <div className="flex justify-end gap-3">
        <button
          onClick={() => setShowModal(false)}
          className="px-4 py-2 rounded-xl border border-gray-300 dark:border-neutral-700"
        >
          Cancel
        </button>
        <button
          onClick={saveModule}
          disabled={saving}
          className="px-4 py-2 rounded-xl bg-yellow-500 text-black font-medium disabled:opacity-60"
        >
          {saving ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  </div>
)}

    </div>
  );
}